import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

// Extend once on import so `fromNow()` is available app-wide.
dayjs.extend(relativeTime);

/**
 * Formats a timestamp as a short relative string (e.g. "3 minutes ago").
 * Returns an em dash when no date is available.
 */
export function formatRelativeTime(date?: Date | string | null): string {
    if (!date) return "—";
    const parsed = dayjs(date);
    if (!parsed.isValid()) return "—";
    return parsed.fromNow();
}

export { dayjs };
